// extracted by mini-css-extract-plugin
module.exports = {"container":"LotteryNumber_container__HxGzy","mask":"LotteryNumber_mask__2LBhD","content":"LotteryNumber_content__1uEnz"};